export function getQueryParameter(parameter, defaultValue = null) {
    const queryParts = window.location.search.replace("?", "").split("&");
    for (let i = 0; i < queryParts.length; i++) {
        let split = queryParts[i].split("=");
        if (split[0] === parameter) {
            defaultValue = split[1].replace(/[^\w\d]/g, "");
        }
    }
    return defaultValue;
}
